import _toConsumableArray from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { ArrowRight } from "@element-plus/icons";
import { defineComponent, ref, reactive, computed, watch } from "vue";
import { onBeforeRouteUpdate, useRouter } from "vue-router";
import Icon from "@/components/Personal/Icon.vue";
import VuePictureCropper, { cropper } from "vue-picture-cropper";
import { ElMessageBox, ElMessage } from "element-plus";
import 'element-plus/es/components/message-box/style/index'
import 'element-plus/es/components/message/style/index'

import useCurrentInstance from "@/hooks/useCurrentInstance";
import Breads from "@/components/Breads/index.vue";
import { deleteAllCookies } from "@/hooks/auth";
import { useStore } from "vuex";
export default defineComponent({
  name: "Personal",
  components: {
    Icon: Icon,
    VuePictureCropper: VuePictureCropper,
    Breads: Breads
  },
  setup: function setup() {
    var _meunList$value$index, _meunList$value$index2;

    var itemName = ref('');
    var router = useRouter();

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var details = reactive({
      allPath: [{
        path: "",
        name: "个人信息",
        query: {}
      }]
    });
    var store = useStore(); // 左侧列表

    var meunList = ref(store.state.column.meunList); //默认配置
    //缓存路由

    var setArray = new Set(["Personal", "AnnualCheck"]);
    var keepRoute = ref([]); // 资料个人资料

    var Data = reactive({
      expandList: [],
      dataExpand: [],
      detail: {}
    }); // 图片路径前缀

    var baseUrl = process.env.VUE_APP_BASE_URL; //图片裁剪

    var shores = ref(false);
    var fileName = ref("");
    var uploadInput = ref();
    var pic = ref("");
    var result = reactive({
      dataURL: "",
      blobURL: ""
    });

    function getPhopto() {
      setTimeout(function () {
        uploadInput.value.click();
      }, 1000);
    } //头像参数

    /**
     * 选择图片
     */


    var selectFile = function selectFile(e) {
      // 重置上一次的结果
      result.dataURL = "";
      result.blobURL = ""; // 如果有多个裁剪框，也需要重置掉裁剪目标的值，避免使用同一张图片无法触发watch

      pic.value = ""; // 获取选取的文件

      var target = e.target;
      var files = target.files;
      if (!files) return;
      var file = files[0];
      fileName.value = file.name.slice(0, file.name.lastIndexOf(".")); // 转换为base64传给裁切组件

      var reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = function () {
        // 更新裁切弹窗的图片源
        pic.value = String(reader.result); // 显示裁切弹窗

        shores.value = true; // 清空已选择的文件

        if (!uploadInput.value) return;
        uploadInput.value.value = "";
      };
    };

    var stateName = ref();
    stateName.value = useStore();
    watch(function () {
      return stateName.value.state.column.isback;
    }, function (newPath) {
      console.log(newPath);

      if (newPath == 1) {
        nowInsert.value = itemName.value;
      } else {
        if (newPath == 0) {
          nowInsert.value = "网上考试";
        }
      }

      stateName.value.dispatch("column/isback", -1);
    });
    /**
     * 获取裁切结果
     */

    var getResult = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var file, formData, _yield$globalProperti, data, _yield$globalProperti2, code;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return cropper.getFile({
                  fileName: fileName.value
                });

              case 2:
                file = _context.sent;
                formData = new FormData();
                formData.append("file", file);
                _context.next = 7;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["upload"](formData);

              case 7:
                _yield$globalProperti = _context.sent;
                data = _yield$globalProperti.data;
                _context.next = 11;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["uploadHead"]({
                  userId: Data.detail.userId,
                  headIcon: data.fileName
                });

              case 11:
                _yield$globalProperti2 = _context.sent;
                code = _yield$globalProperti2.code;

                if (code == 0) {
                  getUser();
                  shores.value = false;
                } else {
                  ElMessage.error("保存失败");
                } // // 把base64赋给结果展示区
                // result.dataURL = base64
                // try {
                //   result.blobURL = URL.createObjectURL(blob)
                // } catch (e) {pRoute
                //   result.blobURL = ''
                // }
                // 隐藏裁切弹窗


              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getResult() {
        return _ref.apply(this, arguments);
      };
    }();
    /**
     * 重置默认的裁切区域
     */


    var reset = function reset() {
      cropper.reset();
    }; //默认选中


    var routerUrl = ref(router.currentRoute.value.fullPath);
    meunList.value.some(function (item) {
      if (item.flag) {
        routerUrl.value = item.router;
        router.replace(item.router);
      }

      return item.flag;
    });
    var index = meunList.value.findIndex(function (v) {
      return v.router == routerUrl.value;
    });
    var nowInsert = ref(index >= 0 ? meunList.value[index].name : meunList.value[0].name);
    setArray.add((_meunList$value$index = meunList === null || meunList === void 0 ? void 0 : (_meunList$value$index2 = meunList.value[index]) === null || _meunList$value$index2 === void 0 ? void 0 : _meunList$value$index2.keepName) !== null && _meunList$value$index !== void 0 ? _meunList$value$index : "");
    keepRoute.value = _toConsumableArray(setArray);
    store.dispatch('keppPersonLive/setKeepView', keepRoute.value); //默认不显示返回按钮

    var nowback = ref(false); //跳转路由

    var insetIt = function insetIt(val, url, keepName) {
      details.allPath[0].name = val;
      itemName.value = val;
      nowInsert.value = val;
      router.replace(url); // sessionStorage.setItem("url", url);

      setArray.add(keepName !== null && keepName !== void 0 ? keepName : "");
      keepRoute.value = _toConsumableArray(setArray); //清空其他keepname

      keepRoute.value = keepRoute.value.filter(function (val) {
        return val == keepName || val == "Personal";
      });
      store.dispatch('keppPersonLive/setKeepView', keepRoute.value);
    };

    var getkeepViews = computed(function () {
      return store.state.keppPersonLive.keepViews;
    });
    getUser(); // 获取用户信息

    function getUser() {
      return _getUser.apply(this, arguments);
    } //更换标题以及是否需要返回按钮
    //返回方法


    function _getUser() {
      _getUser = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _yield$globalProperti4, data;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getInformation"]();

              case 2:
                _yield$globalProperti4 = _context3.sent;
                data = _yield$globalProperti4.data;
                Object.assign(Data.detail, data);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _getUser.apply(this, arguments);
    }

    function back() {
      router.back();
    }

    onBeforeRouteUpdate(function (to) {
      meunList.value.forEach(function (ele) {
        if (to.fullPath == ele.router && nowInsert.value != ele.name) {
          nowInsert.value = ele.name;
        }
      }); // 
    }); // onBeforeRouteLeave(() => {
    //   sessionStorage.removeItem("url");
    // });
    //退出登录

    function logout() {
      ElMessageBox.confirm("确认是否退出", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$globalProperti3, code;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["logout"]();

              case 2:
                _yield$globalProperti3 = _context2.sent;
                code = _yield$globalProperti3.code;

                if (code == 0) {
                  // sessionStorage.clear();
                  deleteAllCookies();
                  router.push("/login");
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))).catch(function () {// catch error
      });
    }

    return {
      meunList: meunList,
      insetIt: insetIt,
      nowInsert: nowInsert,
      nowback: nowback,
      back: back,
      keepRoute: keepRoute,
      logout: logout,
      ArrowRight: ArrowRight,
      Data: Data,
      baseUrl: baseUrl,
      // 头像裁剪相关参数
      uploadInput: uploadInput,
      pic: pic,
      result: result,
      shores: shores,
      // 方法
      getPhopto: getPhopto,
      selectFile: selectFile,
      getResult: getResult,
      reset: reset,
      details: details,
      getkeepViews: getkeepViews
    };
  }
});